import React from 'react';
import { Row, Col, Grid } from 'antd';
import { Header } from './Header';
import { useEwaContext } from '../context';
import { useGetCustomReportResults } from '@/hooks';
import { RESULT_PDF_SECTIONS } from './Steps/Results/constants';
import { DIRECTION } from '@/components/ui/StepsNavigation/types';
import { StepsNavigation } from '@/components/ui/StepsNavigation';
import { useApplicationContext } from '@/context/v1/Application/context';
import { CustomFormContainer } from './styles';

export function Report (): JSX.Element {
	const breakpoints = Grid.useBreakpoint();
	const { organization, company } = useApplicationContext();
	const { steps, currentStep, handleStepNagivationClick, ewa, customReport } = useEwaContext();

	const { data: result } = useGetCustomReportResults({
		file_id: ewa?.file_id,
		company_id: company?.id,
		report_id: customReport.id,
		organization_id: organization?.id,
		custom_report_result_id: ewa.result_id,
		selected_pdf_sections: RESULT_PDF_SECTIONS
	});

	const isConsolidated = Boolean(result.consolidated);

	return (
		<Row justify="center">
			<Col xs={24}>
				<Header />
			</Col>
			<Col span={24} style={{ marginTop: '2rem' }}>
				<Row justify="center" gutter={[16, 0]}>
					<Col xs={24} xxl={4}>
						<StepsNavigation
							steps={steps}
							currentStep={currentStep}
							isComplete={ewa.is_completed}
							isConsolidated={isConsolidated}
							onStepNagivationClick={handleStepNagivationClick}
							direction={!breakpoints.xxl ? DIRECTION.HORIZONTAL : DIRECTION.VERTICAL}
						/>
					</Col>
					<CustomFormContainer xs={24} xxl={18} $isSmallScreen={`${breakpoints.lg}`}>
						{steps[currentStep]?.component}
					</CustomFormContainer>
				</Row>
			</Col>
		</Row>
	);
};
